import actions from "./actions";
import dayjs from 'dayjs';
import {Type} from "../Transaction/helper";

let idx, line, transaction, items, item;

const isNumberEmpty = value => value === '' || value === null || value === undefined;

const isItemDirty = (item, transactionType) => {
    switch (transactionType) {
        case Type.sale_invoice:
        case Type.purchase_bill: {
            const { account_id, quantity, description, unit_price, amount } = item;
            return !account_id || !quantity || !description || isNumberEmpty(unit_price) ||
                isNumberEmpty(amount);
        }
        case Type.bank_income:
        case Type.bank_expense: {
            const { account_id, description, amount } = item;
            return !account_id || !description || isNumberEmpty(amount);
        }
        default:
            return false;
    }
};

const initState = {
    transaction: {
        file_id: undefined,
        type: undefined,
        payment_mode: undefined,
        contact_id: undefined,
        contact_name: undefined,
        contact2_id: undefined,
        contact2_name: undefined,
        date: undefined, // moment
        due_date: undefined,
        account_id: undefined,
        number: undefined,
        tag_ids: [],
        items: [],
        currency_code: undefined,
        exchange_rate: undefined,
        tax_mode: undefined,
    },
    type: undefined,
    paymentMode: undefined,
    contactName: undefined,
    contact2Name: undefined,
    date: undefined,
    itemMode: undefined,
    items: [],
    itemIndex: undefined,
    currencyCode: undefined,
    exchangeRate: undefined,
    taxMode: undefined,
    createState: undefined,
    createResult: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.SHOEBOX_TRANSACTION_SET:
            transaction = {
                ...(action.reset ? initState.transaction : state.transaction),
                ...action.transaction,
            };

            items = [...transaction.items];
            items.forEach(item => ({
                ...item,
                dirty: isItemDirty(item, transaction.type),
            }));

            return {
                ...state,
                transaction,
                type: transaction.type,
                paymentMode: transaction.payment_mode,
                contactName: transaction.contact_name,
                contact2Name: transaction.contact2_name,
                date: dayjs(transaction.date),
                items,
                currencyCode: transaction.currency_code,
                exchangeRate: transaction.exchange_rate,
                taxMode: transaction.tax_mode,
            };
        case actions.SHOEBOX_TRANSACTION_SET_TYPE:
            return {
                ...state,
                type: action.typeString,
            };
        case actions.SHOEBOX_TRANSACTION_SET_PAYMENT_MODE:
            return {
                ...state,
                paymentMode: action.paymentMode,
            };
        case actions.SHOEBOX_TRANSACTION_SET_CONTACT_NAME:
            return {
                ...state,
                contactName: action.contactName,
            };
        case actions.SHOEBOX_TRANSACTION_SET_CONTACT2_NAME:
            return {
                ...state,
                contact2Name: action.contact2Name,
            };
        case actions.SHOEBOX_TRANSACTION_SET_DATE:
            return {
                ...state,
                date: action.date,
            };
        case actions.SHOEBOX_TRANSACTION_SET_CURRENCY_CODE:
            return {
                ...state,
                currencyCode: action.currencyCode,
            };
        case actions.SHOEBOX_TRANSACTION_SET_EXCHANGE_RATE:
            return {
                ...state,
                exchangeRate: action.exchangeRate,
            };
        case actions.SHOEBOX_TRANSACTION_SET_TAX_MODE:
            return {
                ...state,
                taxMode: action.taxMode,
            };
        case actions.SHOEBOX_TRANSACTION_SET_ITEM_MODE:
            return {
                ...state,
                itemMode: action.itemMode,
            };
        case actions.SHOEBOX_TRANSACTION_ADD_ITEM: { // Add to the end of the list
            const item = {...action.item};
            item.dirty = isItemDirty(item, state.type);
            return {
                ...state,
                items: [
                    ...state.items,
                    item,
                ],
            };
        }
        case actions.SHOEBOX_TRANSACTION_SET_ITEM: // Support partial update (Must have line)
            items = [...state.items];
            idx = items.findIndex(item => item.line === action.item.line);

            // Merge the item
            item = {
                ...items[idx],
                ...action.item,
            };
            item.dirty = isItemDirty(item, state.type);

            // Merge back to items
            items[idx] = item;

            return {
                ...state,
                items,
            };
        case actions.SHOEBOX_TRANSACTION_SET_ITEMS:
            return {
                ...state,
                items: action.items,
            };
        case actions.SHOEBOX_TRANSACTION_REMOVE_ITEM: { // Delete from the list by line
            // Cannot remove last one
            if (state.items.length <= 1)
                return state;

            let items = [...state.items];
            idx = items.findIndex(item => item.line === action.line);
            items.splice(idx, 1);

            // Reposition
            line = 0;
            items = items.map(item => {
                line += 1;
                return {
                    ...item,
                    line,
                };
            });

            return {
                ...state,
                items,
            };
        }
        case actions.SHOEBOX_TRANSACTION_SET_ITEM_INDEX:
            return {
                ...state,
                itemIndex: action.line,
            };
        case actions.SHOEBOX_TRANSACTION_CREATE_REQUEST:
            return {
                ...state,
                createState: 'request',
            };
        case actions.SHOEBOX_TRANSACTION_CREATE_SUCCESS:
            return {
                ...state,
                createState: 'success',
            };
        case actions.SHOEBOX_TRANSACTION_CREATE_ERROR:
            return {
                ...state,
                createState: 'error',
                createResult: action.error,
            };
        case actions.SHOEBOX_TRANSACTION_RESET:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
